import { render, staticRenderFns } from "./homecare.vue?vue&type=template&id=60fb5212&scoped=true"
import script from "./homecare.vue?vue&type=script&lang=js"
export * from "./homecare.vue?vue&type=script&lang=js"
import style0 from "./homecare.vue?vue&type=style&index=0&id=60fb5212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fb5212",
  null
  
)

export default component.exports